var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ProcessingPayment,{attrs:{"reservation-info":_setup.reservation,"hotel-info":_setup.hotel,"order-info":_setup.order,"is-loading":_setup.isLoadingNext},on:{"click:ok":_setup.onClickOk}})
}
var staticRenderFns = []

export { render, staticRenderFns }